export default __webpack_public_path__ + "palindrome-highlighter.28F98.jpg";